import { Controller } from "@hotwired/stimulus"

// CTA settings controller for admin page form
// Manages field state interactions for CTA variant configuration
export default class extends Controller {
  static targets = [
    "masterToggle",
    "field",
    "sidebarSection",
    "contentSection",
    "contentExclude",
    "contentVariantField"
  ]

  connect() {
    this.toggleFields()
    this.toggleContentVariant()
  }

  // Disable all CTA fields when master hide_cta checkbox is checked
  toggleFields() {
    if (!this.hasMasterToggleTarget) return

    const isHidden = this.masterToggleTarget.checked

    // Disable all field targets
    this.fieldTargets.forEach(field => {
      field.disabled = isHidden
    })

    // Also disable the content exclude checkbox
    if (this.hasContentExcludeTarget) {
      this.contentExcludeTarget.disabled = isHidden
    }

    // Update visual state of sections
    if (this.hasSidebarSectionTarget) {
      this.sidebarSectionTarget.style.opacity = isHidden ? "0.5" : "1"
      this.sidebarSectionTarget.style.pointerEvents = isHidden ? "none" : "auto"
    }

    if (this.hasContentSectionTarget) {
      this.contentSectionTarget.style.opacity = isHidden ? "0.5" : "1"
      this.contentSectionTarget.style.pointerEvents = isHidden ? "none" : "auto"
    }
  }

  // Hide content variant dropdown when content CTA is excluded
  toggleContentVariant() {
    if (!this.hasContentExcludeTarget || !this.hasContentVariantFieldTarget) return

    const isExcluded = this.contentExcludeTarget.checked
    this.contentVariantFieldTarget.style.display = isExcluded ? "none" : "block"
  }
}
